const ALLOWED_DOMAIN = "@flambeau.quebec";

export function isFlambeauEmail(email: string | null | undefined): boolean {
  if (!email) return false;
  return email.toLowerCase().endsWith(ALLOWED_DOMAIN);
}
